/**
 * BrowserInstructions Component
 * Displays browser-specific instructions for enabling permissions
 */

import React from 'react'
import { Box, Typography } from '@mui/material'
import { INTERAX_COLORS } from '../../../../constants/colors'
import { useTranslation } from '../../../../shared/hooks/useIntractionTranslate'
import { BrowserType } from '../../helpers/browserDetection'

interface BrowserInstructionsProps {
  browser: BrowserType
}

export const BrowserInstructions: React.FC<BrowserInstructionsProps> = ({ browser }) => {
  const { t } = useTranslation()

  const renderInstructions = () => {
    if (browser === 'chrome' || browser === 'edge') {
      return (
        <>
          <strong>{t('gamer.permissionScreen.browser.chrome.title')}:</strong>{' '}
          {t('gamer.permissionScreen.browser.chrome.instructions')}
        </>
      )
    }

    if (browser === 'firefox') {
      return (
        <>
          <strong>{t('gamer.permissionScreen.browser.firefox.title')}:</strong>{' '}
          {t('gamer.permissionScreen.browser.firefox.instructions')}
        </>
      )
    }

    if (browser === 'safari') {
      return (
        <>
          <strong>{t('gamer.permissionScreen.browser.safari.title')}:</strong>{' '}
          {t('gamer.permissionScreen.browser.safari.instructions')}
        </>
      )
    }

    // Unknown browser - show all instructions
    return (
      <>
        <strong>{t('gamer.permissionScreen.browser.chrome.title')}:</strong>{' '}
        {t('gamer.permissionScreen.browser.chrome.instructions')}
        <br />
        <strong>{t('gamer.permissionScreen.browser.firefox.title')}:</strong>{' '}
        {t('gamer.permissionScreen.browser.firefox.instructions')}
        <br />
        <strong>{t('gamer.permissionScreen.browser.safari.title')}:</strong>{' '}
        {t('gamer.permissionScreen.browser.safari.instructions')}
      </>
    )
  }

  return (
    <Box
      sx={{
        mt: 2,
        p: 2,
        backgroundColor: `${INTERAX_COLORS.heritageBlue}99`,
        borderRadius: '8px',
        width: '100%'
      }}
    >
      <Typography
        sx={{
          color: INTERAX_COLORS.white,
          fontSize: '14px',
          textAlign: 'left',
          mb: 1,
          fontWeight: 600
        }}
      >
        {t('gamer.permissionScreen.howToEnable')}
      </Typography>
      <Typography
        sx={{
          color: `${INTERAX_COLORS.white}dd`,
          fontSize: '13px',
          textAlign: 'left',
          lineHeight: 1.6
        }}
      >
        {renderInstructions()}
      </Typography>
    </Box>
  )
}
